<template>
  <div class="home background-gray min-height-inherit">
    <section class="py-4 py-md-5">
      <div class="container container--md">
        <header class="user-schedules__header">
          <h1 class="title text-uppercase text-primary">
            <span v-if="current_user.user" class="weight-bolder"
              >{{ current_user.user.firstname }},
            </span>
            <span
              v-text="
                appointments.length
                  ? `tienes (${appointments.length}) ${
                      appointments.length === 1
                        ? 'hora agendada'
                        : 'horas agendadas'
                    }:`
                  : 'no tienes horas agendadas'
              "
            ></span>
          </h1>
        </header>
        <div v-if="appointments.length" class="user-schedules mb-4">
          <div class="user-schedules__list">
            <div
              v-for="appointment in appointments"
              class="user-schedule box mb-4"
              :key="appointment.id"
            >
              <div class="user-schedule__details">
                <div class="row">
                  <div class="col-md-6">
                    <div class="mb-3">
                      <h3 class="title text-primary weight-bolder">
                        Código de reserva:
                      </h3>
                      <p class="mb-0">{{ appointment.reservation_code }}</p>
                    </div>
                    <div class="mb-3 mb-lg-0">
                      <h3 class="title text-primary weight-bolder">
                        {{ current_user.car.brand.name }}
                      </h3>
                      <p v-if="current_user.user" class="mb-0">
                        {{ current_user.car.model.name }}
                      </p>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div>
                      <div class="user-schedule__item">
                        <p
                          class="user-schedule__title text text-capitalize weight-bolder mb-0"
                        >
                          <i class="material-icons text-primary">date_range</i>
                          {{ dateFormat(appointment.appointment_date) }} -
                          {{ formattedTime(appointment.appointment_time) }} hrs
                        </p>
                      </div>
                      <div class="user-schedule__item">
                        <p class="user-schedule__title text weight-bolder mb-0">
                          <i class="material-icons text-primary">place</i
                          >{{ appointment.branch.address }}
                        </p>
                        <p class="user-schedule__text text">
                          {{ appointment.branch.name }}
                        </p>
                      </div>
                      <div class="user-schedule__item">
                        <p class="user-schedule__title text weight-bolder mb-0">
                          <i class="material-icons text-primary"
                            >perm_identity</i
                          >
                          {{ appointment.user.name }}
                          {{ appointment.user.lastname }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="user-schedule__actions">
                <div class="row">
                  <div class="col-md-6">
                    <button
                      class="button button--delete w-100"
                      @click="handleShowModal(true, appointment)"
                    >
                      <i class="button__icon material-icons">highlight_off</i>
                      <span class="button__text">Anular hora</span>
                    </button>
                  </div>
                  <div class="col-md-6 mt-3 mt-md-0">
                    <button
                      class="button button--primary w-100"
                      @click="handleReschedule(appointment)"
                    >
                      <i class="button__icon material-icons">date_range</i>
                      <span class="button__text">Reprogramar hora</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="new-schedule">
          <figure v-if="!appointments.length" class="new-schedule__image">
            <img class="img-fluid" :src="current_brand.background" />
          </figure>
          <div class="new-schedule__content box">
            <h3
              class="new-schedule__title title text-uppercase text-primary weight-bolder"
            >
              <i class="material-icons">date_range</i>
              <span
                v-text="
                  appointments.length ? 'Agendar otra hora' : 'Agendar una hora'
                "
              ></span>
            </h3>
            <p class="text mt-2 mb-0">
              Te damos la mejor atención de forma rápida y simple, ingresa para
              agendar tu mantención
            </p>
            <router-link
              class="new-schedule__action button button--circle"
              :to="{ name: 'schedule' }"
            >
              <i class="button__icon material-icons">navigate_next</i>
            </router-link>
          </div>
        </div>
      </div>
    </section>

    <modal v-if="showModal" class="modal--md" @close="handleShowModal(false)">
      <div class="modal-header" slot="header">
        <h1 class="title title--m text-primary text-center weight-bolder">
          ¿Estás seguro de anular tu hora de agendamiento?
        </h1>
      </div>
      <div slot="body">
        <div class="mb-3">
          <h3 class="title text-primary weight-bolder">Código de reserva:</h3>
          <p class="mb-0">{{ currentAppointment.reservation_code }}</p>
        </div>
        <div class="mb-4">
          <h3 class="title text-primary weight-bolder">
            {{ current_brand.name }}
          </h3>
          <p v-if="current_user.user" class="mb-0">
            {{ current_user.car.model.name }}
          </p>
        </div>
        <div>
          <div class="user-schedule__item">
            <p
              class="user-schedule__title text text-capitalize weight-bolder mb-0"
            >
              <i class="material-icons text-primary">date_range</i>
              {{ dateFormat(currentAppointment.appointment_date) }} -
              {{ formattedTime(currentAppointment.appointment_time) }} hrs
            </p>
          </div>
          <div class="user-schedule__item">
            <p class="user-schedule__title text weight-bolder mb-0">
              <i class="material-icons text-primary">place</i
              >{{ currentAppointment.branch.address }}
            </p>
            <p class="user-schedule__text text">
              {{ currentAppointment.branch.name }}
            </p>
          </div>
          <div class="user-schedule__item">
            <p class="user-schedule__title text weight-bolder mb-0">
              <i class="material-icons text-primary">perm_identity</i>
              {{ currentAppointment.user.name }}
              {{ currentAppointment.user.lastname }}
            </p>
          </div>
        </div>
      </div>
      <div class="modal-footer" slot="footer">
        <button
          class="button button--delete w-100"
          @click="cancelAppointment(currentAppointment)"
          :disabled="loading"
        >
          <i class="button__icon material-icons">highlight_off</i>
          <span
            class="button__text"
            v-text="loading ? 'Anulando' : 'Anular hora'"
          ></span>
        </button>
      </div>
    </modal>
  </div>
</template>

<script>
import { deleteAppointment } from '@/services/schedule';

import Modal from '@/components/Modal.vue';

import moment from 'moment';
import { mapState } from 'vuex';
import Auth from '@/helpers/auth';

export default {
  name: 'Home',
  mixins: [Auth],
  components: {
    Modal,
  },
  data() {
    return {
      loading: false,
      showModal: false,
      currentAppointment: null,
    };
  },
  mounted() {
    this.$store.commit(
      'set_title',
      `Hola ${this.current_user.user.firstname}, ¿qué necesitas hacer?`,
    );

    this.checkAuth();

    this.$store.dispatch('setCurrentStep', 0);
    this.handleGetUserSchedules();
  },
  computed: {
    ...mapState(['current_brand', 'current_user', 'appointments']),
  },
  methods: {
    handleGetUserSchedules() {
      this.$store.dispatch('getUserAppoinments');
    },
    handleShowModal(show, data) {
      this.showModal = show;
      this.currentAppointment = data || null;
    },
    cancelAppointment(appointment) {
      this.loading = true;

      const data = {
        _method: 'DELETE',
      };

      this.deleteAppointmentFromApi(appointment.reservation_code, data)
        .then(() => this.$router.push({ name: 'schedule-cancel' }))
        .catch(() => {
          this.handleShowModal(false);
          this.$notify({
            group: 'general',
            type: 'error',
            title: 'Ha ocurrido un error',
            text: 'No hemos podido eliminar tu hora',
          });
        })
        .then(() => (this.loading = false));
    },
    handleReschedule(appointment) {
      const service_slug = appointment.service.name.toSlug();

      this.$store.dispatch('setCurrentSchedule', appointment).then(() =>
        this.$router.push({
          name: 'schedule-place',
          params: { service: service_slug },
        }),
      );
    },
    formattedTime(time) {
      return time.substring(0, time.length - 3);
    },
    dateFormat(date) {
      return moment(date)
        .locale('es')
        .format('dddd DD MMMM');
    },
    async deleteAppointmentFromApi(id, data) {
      const response = await deleteAppointment(id, data);
      return response.data.data;
    },
  },
};
</script>
